module.exports = __webpack_public_path__ + "img/art-like.a92fe1c9.png";